import React from "react";
import { Link } from "react-router-dom";

const GuideTableOfContents = ({ sections, basePath }) => (
  <nav className="guide-toc" aria-label="Guide table of contents">
    <h2 className="guide-toc__title">In this guide</h2>
    <ol className="guide-toc__list">
      {sections.map((section) => (
        <li key={section.id} className="guide-toc__item">
          <Link to={`${basePath}/${section.id}`} className="guide-toc__link">
            <span className="guide-toc__label">
              <span className="guide-toc__number">{section.position}.</span>
              {section.name}
            </span>
          </Link>
        </li>
      ))}
    </ol>
  </nav>
);

export default GuideTableOfContents;
